import { requirementsView } from '../../../../../../../../config/constants.js';

export default (id) => {
    $$(requirementsView).add({
        id, name: '', assinge_id: null, date: '',
    }, 0);
    $$(requirementsView).edit({ row: id, column: 'name' });
};
